import { post } from '../request';
import { APP_CONFIG } from '../../config';
import type { ITenantProtectionStarted } from '../../@types/tenantProtection';

export const startTenantProtection = async () => {
  return await post<ITenantProtectionStarted, undefined>(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/tenant-protection/start`,
    undefined,
    'XSRF-TOKEN',
  );
};

export const validateToken = async (token: string) => {
  return await post<boolean, { token: string }>(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/tenant-protection/validate-token`,
    { token },
    'XSRF-TOKEN',
  );
};
